import './css/Aulas.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { show_alerta } from '../../funciones.js';
import PerfilLogo from '../usuarios/PerfilLogo.js';
import { 
    asignarEstudianteAlCurso, 
    asignarEstudianteSoloCurso, 
    quitarEstudianteAlCurso, 
    quitarEstudianteSoloCurso 
} from '../../servicios/cursoServicios';
import useCursoData from '../../hooks/useCursoData';
import CONFIG from '../../config';
import { Link } from 'react-router-dom';

const URL_LISTAR = `${CONFIG.API_URL}/listarUsuarios.php`;

function CursoGrupoEstudiantes({ id_curso_grupo, setCantidadEstudiantes, configuracion }) {
    const rol = sessionStorage.getItem('rol');
    const { estudiantesCurso, fetchEstudiantesCurso } = useCursoData(id_curso_grupo);
    const [estudiantes, setEstudiantes] = useState([]);
    const [buscar, setBuscar] = useState('');
    const [buscar2, setBuscar2] = useState('');
    const [estudiantesSeleccionados, setEstudiantesSeleccionados] = useState([]);
    let filtroGrupoEstudiantes = [];
    let filtroEstudiantes = [];

    useEffect(() => {
        buscaEstudiantes();
    }, []);

    const buscaEstudiantes = () => {
        axios.post(URL_LISTAR, { 'id_rol': 7, 'modo': 'buscaUsuariosPorRol' })
            .then(res => {
                if (!res.data.error) {
                    setEstudiantes(res.data);
                } else {
                    setEstudiantes([]);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    const handleAsignarEstudiantes = async (modoAsignacion) => {
        if (estudiantesSeleccionados.length === 0) {
            show_alerta('No se seleccionaron estudiantes', 'error');
            return;
        }

        let exitos = 0;
        for (const estudianteId of estudiantesSeleccionados) {
            const estudianteYaAsignado = estudiantesCurso.some(estudiante => estudiante.id === estudianteId);
            if (estudianteYaAsignado) {
                show_alerta('Uno o más estudiantes ya están inscriptos en este curso', 'error');
                continue;
            }

            let res;
            if (modoAsignacion === 'soloCurso') {
                res = await asignarEstudianteSoloCurso(id_curso_grupo, estudianteId);
            } else {
                res = await asignarEstudianteAlCurso(id_curso_grupo, estudianteId);
            }

            if (res && res.data && (res.data[0] === 'success' || res.data.success)) {
                exitos++;
            } else {
                const msj = (res && res.data && res.data[1]) ? res.data[1] : 'Error en la asignación';
                show_alerta(msj, 'error');
            }
        }

        if (exitos > 0) {
            show_alerta(
                modoAsignacion === 'soloCurso' 
                    ? 'Estudiante(s) agregado(s) solo a este curso' 
                    : 'Estudiante(s) agregado(s) a todos los cursos del año', 
                'success'
            );
            const btnCerrar = document.getElementById('botonCerrarListaEstudiantes');
            if (btnCerrar) btnCerrar.click();
            setEstudiantesSeleccionados([]);
            fetchEstudiantesCurso();
        }
    };

    // Quitar estudiante de TODOS los cursos del mismo orden/año
    const quitarEstudianteTodosLosCursos = (id) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: '¿Quitar de TODOS los cursos del año?',
            text: 'El/la estudiante será desvinculado/a de todos los cursos del mismo orden y división.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '<i class="fa-solid fa-users-slash"></i> Sí, quitar de todos',
            cancelButtonText: 'Cancelar',
            customClass: {
                confirmButton: 'btn btn-danger mx-2 shadow-sm',
                cancelButton: 'btn btn-outline-secondary mx-2',
                popup: 'rounded-4 shadow'
            },
            buttonsStyling: false
        })
        .then(res => {
            if (res.isConfirmed) {
                enviarSolicitudQuitarTodos(id);
            }
        });
    };

    const enviarSolicitudQuitarTodos = async (id) => {
        const res = await quitarEstudianteAlCurso(id);
        if (res && res.data) {
            var tipo = res.data[0];
            var msj = res.data[1];
            show_alerta(msj, tipo);
            if (tipo === 'success') {
                fetchEstudiantesCurso();
            }
        }
    };

    // Quitar estudiante SOLO del curso actual
    const quitarEstudianteSoloCursoActual = (id) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: '¿Quitar SOLO de este curso?',
            text: 'El/la estudiante será desvinculado/a únicamente de este curso.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '<i class="fa-solid fa-user-minus"></i> Sí, quitar solo de este curso',
            cancelButtonText: 'Cancelar',
            customClass: {
                confirmButton: 'btn btn-warning mx-2 shadow-sm',
                cancelButton: 'btn btn-outline-secondary mx-2',
                popup: 'rounded-4 shadow'
            },
            buttonsStyling: false
        })
        .then(res => {
            if (res.isConfirmed) {
                enviarSolicitudQuitarSoloActual(id);
            }
        });
    };

    const enviarSolicitudQuitarSoloActual = async (id) => {
        const res = await quitarEstudianteSoloCurso(id);
        if (res && res.data) {
            var tipo = res.data[0];
            var msj = res.data[1];
            show_alerta(msj, tipo);
            if (tipo === 'success') {
                fetchEstudiantesCurso();
            }
        }
    };

    // filtro1
    filtroGrupoEstudiantes = !buscar
        ? estudiantesCurso
        : estudiantesCurso.filter((dato) =>
            dato.id_curso_grupo.toLowerCase().includes(buscar.toLowerCase())
        );

    // filtro2
    filtroEstudiantes = !buscar2
        ? estudiantes
        : estudiantes.filter((dato) =>
            dato.nombre.toLowerCase().includes(buscar2.toLowerCase()) ||
            dato.apellido.toLowerCase().includes(buscar2.toLowerCase()) ||
            dato.documento.toString().toLowerCase().includes(buscar2.toLowerCase())
        );

    useEffect(() => {
        if (setCantidadEstudiantes) {
            setCantidadEstudiantes(filtroGrupoEstudiantes.length);
        }
    }, [filtroGrupoEstudiantes.length, setCantidadEstudiantes]);

    const handleSeleccionarEstudiante = (id) => {
        setEstudiantesSeleccionados(prev => {
            if (prev.includes(id)) {
                return prev.filter(estudianteId => estudianteId !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    return (
        <React.Fragment>
            <div>
                <div className='row border-bottom mb-2'>
                    <div className='col-6 col-sm-7'>
                        <h5><i className="fa-solid fa-graduation-cap"></i> Estudiantes en el curso {filtroGrupoEstudiantes.length}</h5>
                    </div>
                    <div className='col-6 col-sm-5 d-flex justify-content-end gap-1'>
                        <button 
                            type='button' 
                            className='btn btn-light btn-sm' 
                            data-bs-toggle="modal" 
                            data-bs-target="#modalAgregarEstudiantes"
                        >
                            <i className="fa-solid fa-circle-plus"></i> estudiante
                        </button>
                    </div>
                </div>
                <div className='mx-1'>
                    {Array.isArray(filtroGrupoEstudiantes) && filtroGrupoEstudiantes.length > 0 &&
                        filtroGrupoEstudiantes.map((ec) => (
                            <div key={ec.id} className='row border-bottom my-1 align-items-center'>
                                <div className='col-6 col-md-7'>
                                    <PerfilLogo usuario={ec} version="extendida+" configuracion={configuracion} />
                                </div>
                                <div className='col-6 col-md-5 d-flex justify-content-end py-1 gap-1'>
                                    {(rol == 9 || rol == "9") && (
                                        <Link to={`/VerPerfil/e/${ec.id_usuario || ec.id}`} className='btn btn-info btn-sm text-white' title='Ver Ficha de Estudiante'>
                                            <i className="fa-solid fa-address-card"></i>
                                        </Link>
                                    )}
                                    {rol != 2 && rol != 3 && rol != 4 && rol != 9 && rol != "9" && (
                                        <>
                                            <button 
                                                type='button' 
                                                className='btn btn-outline-danger btn-sm' 
                                                title='Quitar solo de este curso' 
                                                onClick={() => quitarEstudianteSoloCursoActual(ec.id_estudiante_curso)}
                                            >
                                                <i className="fa-solid fa-user-minus"></i> <span className="d-none d-lg-inline small">Quitar solo de este curso</span>
                                            </button>
                                            <button 
                                                type='button' 
                                                className='btn btn-warning btn-sm' 
                                                title='Quitar de todos los cursos del año' 
                                                onClick={() => quitarEstudianteTodosLosCursos(ec.id_estudiante_curso)}
                                            >
                                                <i className="fa-solid fa-users-slash"></i> <span className="d-none d-lg-inline small">Quitar de todos los cursos del año</span>
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        ))}
                </div>
            </div>

            <div className="modal fade" id="modalAgregarEstudiantes" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                Estudiantes
                                <div className="input-group mt-2">
                                    <span className="input-group-text" id="basic-addon1"><i className="fa-solid fa-magnifying-glass"></i></span>
                                    <input type="text" className="form-control" id='buscar' name='buscar' value={buscar2} onChange={(e) => setBuscar2(e.target.value)} placeholder='buscar...' aria-label='buscar' aria-describedby='basic-addon1' />
                                </div>
                            </h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-8">
                                    {filtroEstudiantes.map((d) => (
                                        <div key={d.id} className='mb-1'>
                                            <input 
                                                className="form-check-input" 
                                                type="checkbox" 
                                                checked={estudiantesSeleccionados.includes(d.id)}
                                                onChange={() => handleSeleccionarEstudiante(d.id)} 
                                                id={`chek_${d.id}`} 
                                                value={d.id} 
                                            />
                                            <label className="form-check-label mx-1 small" htmlFor={`chek_${d.id}`}> 
                                                {d.apellido}, {d.nombre} ({d.documento})
                                            </label>
                                        </div>
                                    ))}
                                </div>
                                <div className="col-4">
                                    {estudiantesSeleccionados.length <= 0 ? <div className='alert alert-info'>No hay estudiantes seleccionados</div>
                                    : <h6>Seleccionados ({estudiantesSeleccionados.length}):</h6>}
                                    <div>
                                        {estudiantesSeleccionados.map(id => {
                                            const estudiante = estudiantes.find(e => e.id === id);
                                            return (
                                                <div key={id} className='small text-truncate'>
                                                    {estudiante ? `${estudiante.apellido}, ${estudiante.nombre}` : id}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer flex-wrap">
                            <button type="button" className="btn btn-secondary me-auto" name='botonCerrar' id="botonCerrarListaEstudiantes" data-bs-dismiss="modal">Cerrar</button>
                            <button type="button" className='btn btn-primary me-2' onClick={() => handleAsignarEstudiantes('soloCurso')}>
                                <i className="fa-solid fa-user-plus me-1"></i> Agregar solo a este curso
                            </button>
                            <button type="button" className='btn btn-success' onClick={() => handleAsignarEstudiantes('todosCursos')}>
                                <i className="fa-solid fa-users me-1"></i> Agregar a todos los cursos del año
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default CursoGrupoEstudiantes;
